(function () {
  "use strict";

  var root = document.getElementById("quiz-root");
  var contentNode = document.getElementById("quiz-content");
  var commerceNode = document.getElementById("quiz-commerce");
  if (!root || !contentNode) return;

  function parseJSON(text) {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  var cfg = parseJSON(contentNode.textContent);
  var shop = parseJSON(commerceNode ? commerceNode.textContent : "") || {};
  if (!cfg || !cfg.steps || !cfg.steps.length || !cfg.results) return;

  var variants = shop.variants || {};
  var nav = cfg.nav || {};
  var shell = cfg.resultShell || {};
  var STARS = "\u2605\u2605\u2605\u2605\u2605";
  var STORE_KEY = "kq:" + (cfg.id || "quiz");
  var timers = [];

  function keysOf(obj) {
    var out = [], k;
    for (k in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, k)) out.push(k);
    }
    return out;
  }

  var resultKeys = keysOf(cfg.results);

  var questionSteps = [];
  for (var qi = 0; qi < cfg.steps.length; qi++) {
    if (cfg.steps[qi].type !== "info") questionSteps.push(cfg.steps[qi].id);
  }

  var state = { index: 0, answers: loadAnswers() };

  function el(id) {
    return document.getElementById(id);
  }

  function attr(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function txt(value) {
    return value == null ? "" : String(value);
  }

  function indexOf(list, needle) {
    for (var i = 0; i < list.length; i++) {
      if (list[i] === needle) return i;
    }
    return -1;
  }

  function loadAnswers() {
    try {
      var raw = window.sessionStorage.getItem(STORE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function saveAnswers() {
    try {
      window.sessionStorage.setItem(STORE_KEY, JSON.stringify(state.answers));
    } catch (e) {}
  }

  function clearTimers() {
    for (var i = 0; i < timers.length; i++) window.clearTimeout(timers[i]);
    timers = [];
  }

  function later(fn, ms) {
    timers.push(window.setTimeout(fn, ms));
  }

  function toTop() {
    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }

  function questionNumber(stepId) {
    return indexOf(questionSteps, stepId) + 1;
  }

  function checkHtml() {
    return cfg.checkIcon
      ? '<img class="qr-check-icon" src="' + attr(cfg.checkIcon) + '" alt="" aria-hidden="true">'
      : "\u2713";
  }

  function findOption(step, value) {
    if (!step.options) return null;
    for (var i = 0; i < step.options.length; i++) {
      if (step.options[i].value === value) return step.options[i];
    }
    return null;
  }

  function topKey(weights) {
    var best = "", bestValue = -Infinity, k;
    for (k in weights) {
      if (!Object.prototype.hasOwnProperty.call(weights, k)) continue;
      var v = Number(weights[k]) || 0;
      if (v > bestValue) {
        bestValue = v;
        best = k;
      }
    }
    return bestValue > 0 ? best : "";
  }

  function compute() {
    var tally = {}, i, k;
    for (i = 0; i < resultKeys.length; i++) tally[resultKeys[i]] = 0;

    var line = "", decider = "";

    for (i = 0; i < cfg.steps.length; i++) {
      var step = cfg.steps[i];
      if (step.type === "info" || !step.options) continue;
      var opt = findOption(step, state.answers[step.id]);
      if (!opt) continue;

      if (opt.weights) {
        for (k in opt.weights) {
          if (Object.prototype.hasOwnProperty.call(tally, k)) {
            tally[k] += Number(opt.weights[k]) || 0;
          }
        }
      }
      if (opt.line) line = opt.line;
      if (step.decides) decider = topKey(opt.weights || {});
    }

    var best = -Infinity, tied = [];
    for (i = 0; i < resultKeys.length; i++) {
      var value = tally[resultKeys[i]];
      if (value > best) {
        best = value;
        tied = [resultKeys[i]];
      } else if (value === best) {
        tied.push(resultKeys[i]);
      }
    }

    var winner = tied[0];
    if (tied.length > 1) {
      if (decider && indexOf(tied, decider) > -1) winner = decider;
      else if (cfg.fallback && indexOf(tied, cfg.fallback) > -1) winner = cfg.fallback;
    }
    if (!cfg.results[winner]) winner = cfg.fallback || resultKeys[0];

    // If the recommended size is sold out, switch to the fallback size.
    // Set "substituteUnavailable": false in the quiz config to always keep
    // the recommended size (so the product page always matches the result).
    var substituted = false;
    if (cfg.substituteUnavailable !== false) {
      var chosen = variants[winner];
      if (chosen && chosen.available === false) {
        var alt = cfg.fallback && variants[cfg.fallback];
        if (alt && alt.available && cfg.fallback !== winner) {
          substituted = winner;
          winner = cfg.fallback;
        }
      }
    }

    return { tally: tally, winner: winner, line: line, substituted: substituted };
  }

  function answersSummary() {
    var parts = [];
    for (var i = 0; i < cfg.steps.length; i++) {
      var step = cfg.steps[i];
      if (step.type === "info") continue;
      var value = state.answers[step.id];
      if (value) parts.push(step.id + "=" + value);
    }
    return parts.join("; ");
  }

  function track(name, detail) {
    var payload = detail || {};
    payload.quiz = cfg.id || "quiz";
    try {
      document.dispatchEvent(new CustomEvent("quiz:" + name, { detail: payload }));
    } catch (e) {}
    if (window.dataLayer && typeof window.dataLayer.push === "function") {
      var copy = { event: "quiz_" + name }, k;
      for (k in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, k)) copy[k] = payload[k];
      }
      window.dataLayer.push(copy);
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "quiz_" + name, payload);
    }
  }

  function tagCart(result, done) {
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      done();
    }
    later(finish, 700);

    var body = {
      attributes: {
        quiz_id: cfg.id || "quiz",
        quiz_recommended: result.winner,
        quiz_size: sizeFor(result.winner),
        quiz_answers: answersSummary()
      }
    };

    try {
      window
        .fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        })
        .then(finish)["catch"](finish);
    } catch (e) {
      finish();
    }
  }

  function variantIdFor(key) {
    var block = cfg.results[key] || {};
    var variant = variants[key] || {};
    return block.variantId || variant.id || "";
  }

  // Size number sent to the product page (e.g. "6", "8", "13").
  // Uses results[key].size, then variants[key].size, then converts the
  // result key ("six" -> "6", "eight" -> "8", "thirteen" -> "13").
  var SIZE_WORDS = { six: "6", eight: "8", thirteen: "13" };

  function sizeFor(key) {
    var block = cfg.results[key] || {};
    var variant = variants[key] || {};
    var raw = String(block.size || variant.size || key).toLowerCase().trim();
    if (SIZE_WORDS[raw]) return SIZE_WORDS[raw];
    var digits = raw.match(/\d+/);
    return digits ? digits[0] : raw;
  }

  function ctaUrl(key) {
    var variant = variants[key] || {};
    var base = shop.productUrl || cfg.productUrl || "";
    var id = variantIdFor(key);
    var url;

    if (base && id) url = base + "?variant=" + encodeURIComponent(id);
    else if (variant.url) url = variant.url;
    else url = base || "/";

    url += url.indexOf("?") > -1 ? "&" : "?";
    url +=
      "quiz=" + encodeURIComponent(cfg.id || "quiz") +
      "&rec=" + encodeURIComponent(key) +
      "&size=" + encodeURIComponent(sizeFor(key));

    if (cfg.ctaAnchor) {
      url += cfg.ctaAnchor.charAt(0) === "#" ? cfg.ctaAnchor : "#" + cfg.ctaAnchor;
    }
    return url;
  }

  function renderProgress(index, done) {
    var wrap = el("quiz-progress-wrap");
    if (!wrap) return;

    var total = questionSteps.length;
    var currentQuestion = 0;

    if (done) {
      currentQuestion = total;
    } else {
      var step = cfg.steps[index];

      if (step && step.type !== "info") {
        currentQuestion = questionNumber(step.id);
      } else {
        for (var i = index + 1; i < cfg.steps.length; i++) {
          if (cfg.steps[i].type !== "info") {
            currentQuestion = questionNumber(cfg.steps[i].id) - 1;
            break;
          }
        }
      }
    }

    var progress = cfg.progress || {};
    var label = done
      ? progress.doneLabel || "Your match is ready!"
      : progress.label || "Finding your match";

    var pct = done ? 100 : Math.round((currentQuestion / total) * 100);

    wrap.style.display = "";
    wrap.innerHTML =
      '<div class="quiz-progress-inner">' +
        '<div class="quiz-progress-header">' +
          '<span class="quiz-progress-label">' + txt(label) + "</span>" +
          '<span class="quiz-progress-count">' + currentQuestion + " / " + total + "</span>" +
        "</div>" +
        '<div class="quiz-progress-bar">' +
          '<div class="quiz-progress-fill" style="width:' + pct + '%"></div>' +
        "</div>" +
      "</div>";
  }

  function trustHtml() {
    if (!cfg.trustLine) return "";
    return (
      '<div class="quiz-trust"><span class="quiz-trust-stars">' +
      STARS +
      "</span><span>" +
      txt(cfg.trustLine) +
      "</span></div>"
    );
  }

  function renderIntro() {
    clearTimers();
    var wrap = el("quiz-progress-wrap");
    if (wrap) wrap.style.display = "none";

    var stage = el("quiz-stage");
    if (!stage) return;

    var intro = cfg.intro || {};
    var features = intro.features || [];
    var featureHtml = "";
    for (var i = 0; i < features.length; i++) {
      featureHtml +=
        '<div class="quiz-intro-feature"><span class="quiz-intro-fi">' +
        txt(features[i].icon) +
        "</span> " +
        txt(features[i].text) +
        "</div>";
    }

    stage.innerHTML =
      '<div class="quiz-intro">' +
      (intro.badge
        ? '<div class="quiz-intro-badge"><span class="quiz-intro-dot"></span> ' + txt(intro.badge) + "</div>"
        : "") +
      '<h1 class="quiz-intro-headline">' + txt(intro.headline) + "</h1>" +
      '<p class="quiz-intro-sub">' + txt(intro.sub) + "</p>" +
      (featureHtml ? '<div class="quiz-intro-features">' + featureHtml + "</div>" : "") +
      '<button class="quiz-btn quiz-intro-btn" id="quiz-start-btn" type="button">' +
      txt(intro.cta || "Start the quiz") +
      '<span class="quiz-btn-arrow">\u2192</span></button>' +
      trustHtml() +
      "</div>";

    var startBtn = el("quiz-start-btn");
    if (startBtn) {
      startBtn.addEventListener("click", function () {
        track("start", {});
        state.index = 0;
        renderStep(0);
        toTop();
      });
    }
  }

  function optionCard(option, stepId) {
    var selected = state.answers[stepId] === option.value;
    return (
      '<button class="quiz-option' + (selected ? " selected" : "") + '"' +
      ' data-step="' + attr(stepId) + '"' +
      ' data-value="' + attr(option.value) + '"' +
      ' type="button" aria-pressed="' + selected + '">' +
      '<span class="quiz-option-icon">' + txt(option.icon) + "</span>" +
      '<span class="quiz-option-body">' +
      '<span class="quiz-option-label">' + txt(option.label) + "</span>" +
      (option.desc ? '<span class="quiz-option-desc">' + txt(option.desc) + "</span>" : "") +
      "</span></button>"
    );
  }

  function renderStep(index) {
    clearTimers();
    var step = cfg.steps[index];
    if (!step) return;

    var stage = el("quiz-stage");
    if (!stage) return;

    var isInfo = step.type === "info";
    var hasAnswer = isInfo || !!state.answers[step.id];
    var isLast = index === cfg.steps.length - 1;
    var eyebrow = isInfo
      ? txt(step.eyebrow || "")
      : (cfg.questionLabel || "Question {n} of {total}")
          .replace("{n}", questionNumber(step.id))
          .replace("{total}", questionSteps.length);

    var optionsHtml = "";
    if (!isInfo && step.options) {
      for (var i = 0; i < step.options.length; i++) {
        optionsHtml += optionCard(step.options[i], step.id);
      }
      optionsHtml = '<div class="quiz-options">' + optionsHtml + "</div>";
    }

    var nextLabel = isLast
      ? nav.last || "See my recommendation"
      : isInfo
      ? nav.continue || "Continue"
      : nav.next || "Next";

    stage.innerHTML =
      '<div class="quiz-step">' +
      '<button class="quiz-back" id="quiz-back-btn" type="button"><span class="quiz-back-arrow">\u2190</span> ' +
      txt(nav.back || "Back") +
      "</button>" +
      (eyebrow ? '<p class="quiz-eyebrow">' + eyebrow + "</p>" : "") +
      '<h2 class="quiz-question">' + txt(step.question) + "</h2>" +
      (step.subtext ? '<p class="quiz-subtext">' + txt(step.subtext) + "</p>" : "") +
      optionsHtml +
      '<div class="quiz-btn-wrap"><button class="quiz-btn" id="quiz-next-btn" type="button"' +
      (hasAnswer ? "" : " disabled") +
      ">" +
      nextLabel +
      ' <span class="quiz-btn-arrow">\u2192</span></button></div>' +
      trustHtml() +
      "</div>";

    var buttons = stage.querySelectorAll(".quiz-option");
    for (var b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener("click", onOptionClick);
    }

    var nextBtn = el("quiz-next-btn");
    if (nextBtn) nextBtn.addEventListener("click", advance);

    var backBtn = el("quiz-back-btn");
    if (backBtn) backBtn.addEventListener("click", goBack);

    renderProgress(index, false);
    track("step_view", { step: step.id, position: index + 1 });
  }

  function onOptionClick() {
    var stepId = this.getAttribute("data-step");
    var value = this.getAttribute("data-value");

    state.answers[stepId] = value;
    saveAnswers();

    var siblings = document.querySelectorAll('.quiz-option[data-step="' + stepId + '"]');
    for (var i = 0; i < siblings.length; i++) {
      var on = siblings[i].getAttribute("data-value") === value;
      siblings[i].classList.toggle("selected", on);
      siblings[i].setAttribute("aria-pressed", on);
    }

    var nextBtn = el("quiz-next-btn");
    if (nextBtn) nextBtn.disabled = false;

    track("answer", { step: stepId, value: value });
  }

  function renderLoading() {
    clearTimers();
    renderProgress(cfg.steps.length, true);

    var stage = el("quiz-stage");
    if (!stage) return;

    var loading = cfg.loading || {};
    var items = loading.items || [];
    var stepMs = Number(loading.stepMs) || 1200;
    var checkMs = Number(loading.checkMs) || 900;

    var itemsHtml = "";
    for (var i = 0; i < items.length; i++) {
      itemsHtml +=
        '<div class="loading-item" id="load-item-' + i + '">' +
        '<div class="loading-check" id="load-check-' + i + '"></div>' +
        "<span>" + txt(items[i]) + "</span></div>";
    }

    stage.innerHTML =
      '<div class="quiz-loading" id="quiz-loading-wrap">' +
      '<div class="loading-spinner" id="loading-spinner"></div>' +
      '<h2 class="loading-title">' + txt(loading.title || "Finding your match \u2026") + "</h2>" +
      '<p class="loading-sub">' + txt(loading.sub || "") + "</p>" +
      '<div class="loading-checklist">' + itemsHtml + "</div>" +
      "</div>";

    for (var j = 0; j < items.length; j++) {
      (function (n) {
        later(function () {
          var item = el("load-item-" + n);
          if (item) item.classList.add("active");
        }, n * stepMs);
        later(function () {
          var item = el("load-item-" + n);
          var check = el("load-check-" + n);
          if (item && check) {
            item.classList.remove("active");
            item.classList.add("done");
            check.innerHTML = checkHtml();
          }
        }, n * stepMs + checkMs);
      })(j);
    }

    later(renderResult, items.length ? (items.length - 1) * stepMs + checkMs + 500 : 600);
  }

  function renderResult() {
    clearTimers();
    var result = compute();
    var block = cfg.results[result.winner];
    if (!block) return;

    var variant = variants[result.winner] || {};
    var stage = el("quiz-stage");
    if (!stage) return;

    var kitHtml = "";
    var kit = block.kit || [];
    for (var i = 0; i < kit.length; i++) {
      kitHtml +=
        '<div class="loading-item done"><div class="loading-check">' +
        checkHtml() +
        "</div><span>" +
        txt(kit[i]) +
        "</span></div>";
    }

    var priceHtml = "";
    // if (cfg.showPrice !== false && variant.price) {
    //   priceHtml =
    //     '<div class="qr-price"><span class="qr-price-now">' +
    //     txt(variant.price) +
    //     "</span>" +
    //     (variant.compareAt ? '<span class="qr-price-was">' + txt(variant.compareAt) + "</span>" : "") +
    //     "</div>";
    // }

    var imageSrc = block.image || variant.image;
    var imageHtml = imageSrc
      ? '<div class="qr-media"><img src="' + attr(imageSrc) + '" alt="' + attr(block.headline) + '" loading="lazy"></div>'
      : "";

    var href = ctaUrl(result.winner);

    stage.innerHTML =
      '<div class="quiz-result">' +
      (shell.eyebrow ? '<p class="quiz-eyebrow">' + txt(shell.eyebrow) + "</p>" : "") +
      '<h2 class="qr-headline">' + txt(shell.headline) + "</h2>" +
      (shell.sub ? '<p class="qr-sub">' + txt(shell.sub) + "</p>" : "") +
      '<div class="qr-card">' +
      imageHtml +
      '<h3 class="qr-title">' + txt(block.headline) + "</h3>" +
      (block.sub ? '<p class="qr-copy">' + txt(block.sub) + "</p>" : "") +
      priceHtml +
      (shell.kitTitle ? '<p class="qr-kit-title">' + txt(shell.kitTitle) + "</p>" : "") +
      '<div class="loading-checklist qr-kit">' + kitHtml + "</div>" +
      (result.line ? '<p class="qr-line">' + txt(result.line) + "</p>" : "") +
      (shell.note ? '<p class="qr-note">' + txt(shell.note) + "</p>" : "") +
      '<a class="kit-ready-btn" id="quiz-cta" href="' + attr(href) + '">' +
      (block.badge ? '<span class="kit-ready-btn-badge">' + txt(block.badge) + "</span>" : "") +
      '<span class="kit-ready-btn-text">' + txt(block.cta) + " \u2192</span></a>" +
      '<div class="quiz-btn-wrap" style="margin-top:14px">' +
      '<button class="quiz-btn-text" id="quiz-retake" type="button"><span class="quiz-back-arrow">\u2190</span> ' +
      txt(nav.retake || "Retake quiz") +
      "</button></div>" +
      "</div>" +
      trustHtml() +
      "</div>";

    var cta = el("quiz-cta");
    if (cta) {
      cta.addEventListener("click", function (event) {
        track("cta_click", {
          recommended: result.winner,
          size: sizeFor(result.winner),
          variant: variantIdFor(result.winner)
        });
        if (!window.fetch) return;
        event.preventDefault();
        tagCart(result, function () {
          window.location.href = href;
        });
      });
    }

    var retake = el("quiz-retake");
    if (retake) {
      retake.addEventListener("click", function () {
        track("retake", {});
        state.answers = {};
        state.index = 0;
        saveAnswers();
        renderIntro();
        toTop();
      });
    }

    track("complete", {
      recommended: result.winner,
      size: sizeFor(result.winner),
      variant: variantIdFor(result.winner),
      substituted: result.substituted || "",
      scores: result.tally
    });

    toTop();
  }

  function advance() {
    var step = cfg.steps[state.index];
    if (!step) return;
    if (step.type !== "info" && !state.answers[step.id]) return;

    if (state.index >= cfg.steps.length - 1) {
      renderLoading();
      toTop();
      return;
    }
    state.index++;
    renderStep(state.index);
    toTop();
  }

  function goBack() {
    if (state.index <= 0) {
      renderIntro();
      toTop();
      return;
    }
    state.index--;
    renderStep(state.index);
    toTop();
  }

  function init() {
    root.innerHTML =
      '<div id="quiz-wrapper">' +
      (cfg.topBarText
        ? '<div class="quiz-topbar">' +
          (cfg.topBarTime ? '<span class="quiz-topbar-time">' + txt(cfg.topBarTime) + "</span>" : "") +
          '<span class="quiz-topbar-text">' + txt(cfg.topBarText) + "</span></div>"
        : "") +
      (cfg.logoUrl
        ? '<header class="quiz-header"><img class="quiz-logo" src="' +
          attr(cfg.logoUrl) +
          '" alt="' + attr(cfg.logoAlt || "KiddoSpace") + '"></header>'
        : "") +
      '<div id="quiz-progress-wrap" style="display:none"></div>' +
      '<main id="quiz-stage" class="quiz-stage" aria-live="polite"></main>' +
      "</div>";

    renderIntro();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();